class FeatureVersioning {

  static supportsMultipleProcesses(processOrDevice) {
    return processOrDevice.featureVersion >= 3
  }

}

export default FeatureVersioning
